import { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import { getEndpointUrl } from "../../Utils/Common";

const UpdateChoiceDetailDialog = ({ visible, onHide, data, choiceGroupId, onSuccess }) => {
    const [isLoading, setLoading] = useState(false);
    const [detail, setDetail] = useState('');

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {
        if (data && visible) {
            setDetail(data.detail || '');
        } else {
            setDetail('');
        }
    }, [data, visible]);

    const onSubmit = async () => {
        if (!data?.id) {
            toast.error("Data detail tidak valid.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }
        if (!detail.trim()) {
            toast.error("Detail wajib diisi.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
            return;
        }

        setLoading(true);
        try {
            const payload = {
                detail: detail.trim(),
                choice_group_id: parseInt(choiceGroupId, 10)
            };

            const res = await fetch(`${getEndpointUrl()}/v2/form_choice_details/${data.id}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesToken}`,
                }),
                body: JSON.stringify(payload)
            });

            const json = await res.json();
            setLoading(false);

            if (json.status === 'ok' && json.results) {
                toast.success("Choice detail berhasil diperbarui.", {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
                onSuccess(json.results);
                onHide();
            } else {
                toast.error(json.message || "Gagal memperbarui choice detail.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        } catch (err) {
            setLoading(false);
            toast.error("Terjadi kesalahan jaringan.", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
            });
        }
    };

    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={visible} onHide={onHide} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isLoading ? "Menyimpan data..." : "Ubah Choice Detail"}
                    </Modal.Title>
                </Modal.Header>

                {isLoading ? (
                    <div className="d-flex justify-content-center mt-5 mb-5">
                        <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                    </div>
                ) : (
                    <>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Detail</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Contoh: Sangat Baik"
                                        value={detail}
                                        onChange={(e) => setDetail(e.target.value)}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onHide}>Batal</Button>
                            <Button variant="primary" onClick={onSubmit}>Simpan</Button>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default memo(UpdateChoiceDetailDialog);